__turbopack_context__.v({
  "cartDrawer": "YKzCAW_cartDrawer",
  "sectionTitle": "YKzCAW_sectionTitle",
  "summaryFloatingWrapper": "YKzCAW_summaryFloatingWrapper",
  "summaryWrapper": "YKzCAW_summaryWrapper",
  "webContent": "YKzCAW_webContent",
  "withRibbon": "YKzCAW_withRibbon",
});
